import React, { useEffect, useState } from 'react';
import {
  Grid,
  TextField,
  FormControl,
  Alert,
  Snackbar,
  Typography,
  Input,
  Button,
  MenuItem,
  InputLabel,
  Select,
  CircularProgress,
  Backdrop
} from '@mui/material';
import { BankNames } from 'API/UserList/DsuserList';
import { BankAccNumberVerify } from 'API/BankAccountVerify';

const BankDetails = (props) => {
  const [BankData, setBankData] = useState('');
  const [NameBank, setNameBank] = useState('');
  const [VerifyResponse, setVerifyResponse] = useState(null);
  const [openLoader, setOpenLoader] = useState(false);
  const [AlerType, setAlertType] = useState('success');
  const [Verified, setVerified] = useState(false);
  const [ErrOpen, setErrOpen] = useState(false);
  const [AlertMessage, setAlertMessage] = useState(null);
  console.log('NameBank', NameBank);
  const BankAccVerified = sessionStorage.getItem('BankAccVerified');

  const UserList = props.UserList;
  // const handleNext = () => {
  //   props.handleStep({
  //     savings_account_holder_name: props.postData.savings_account_holder_name&&props.postData.savings_account_holder_name,
  //     savings_account_ifsc_code: props.postData.savings_account_ifsc_code&&props.postData.savings_account_ifsc_code,
  //     savings_account_number: props.postData.savings_account_number&&props.postData.savings_account_number,
  //     savings_bank_name: props.postData.savings_bank_name&&props.postData.savings_bank_name,
  //     user_id: UserList.user_id
  //   });
  // };
  const handleBankNoVerify = (ifsc_code, account_number, name) => {
    console.log('gfffdsvc', ifsc_code, account_number);

    if (!Verified && !VerifyResponse) {
      BankAccNumberVerify(
        ifsc_code,
        account_number,
        setAlertMessage,
        setErrOpen,
        setVerified,
        setAlertType,
        setOpenLoader,
        setVerifyResponse,
        setNameBank,
        name
        // setFieldChange
      );
    }
  };
  const handleErrClose = () => {
    setErrOpen(false);
  };
  const handleNext = () => {
    const updatedData = Object.keys(props.postData).reduce((acc, key) => {
      if (props.postData[key] !== undefined && props.postData[key] !== null) {
        acc[key] = props.postData[key]; // Store only non-null, non-undefined values
      }
      return acc;
    }, {});

    // Add user_id as a static value
    updatedData.user_id = UserList.user_id;

    props.handleStep(updatedData);
  };
  const handleInput = (e) => {
    const value = e.target.value;
    e.target.value = value.replace(/[^A-Za-z0-9]/g, '');
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    BankNames(setBankData);
  }, []);
  return (
    <>
      <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={openLoader}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar open={ErrOpen} autoHideDuration={5000} onClose={handleErrClose} anchorOrigin={{ vertical: 'top', horizontal: 'right' }}>
        <Alert onClose={handleErrClose} variant="filled" severity={AlerType} sx={{ width: '100%' }}>
          {AlertMessage}
        </Alert>
      </Snackbar>
      <Typography variant="h4" sx={{ mb: 2 }}>
        Bank Details
      </Typography>
      <Grid container spacing={2} fullwidth>
        <Grid item xl={4.5} lg={6} md={6} sm={6} xs={12}>
          <FormControl fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">Savings Bank Name</InputLabel>
            <Select
              label="Savings Bank Name"
              name="savings_bank_name"
              inputProps={{
                readOnly: BankAccVerified
              }}
              variant="standard"
              // onChange={(e) => props.handlePostChange(e)}
              onChange={(e) => {
                const selectedBank = BankData.find((bank) => bank.Bankname.toUpperCase() === e.target.value);
                const firstFourIFSC = selectedBank ? selectedBank.first_four_ifsc : '';

                props.handlePostChange({
                  target: { name: 'savings_bank_name', value: e.target.value }
                });

                props.handlePostChange({
                  target: { name: 'savings_account_ifsc_code', value: firstFourIFSC }
                });
              }}
              value={props.postData.savings_bank_name || UserList.savings_bank_name}
            >
              <MenuItem value={'select'} disabled>
                Select
              </MenuItem>
              <MenuItem value={UserList.savings_bank_name} sx={{ display: 'none' }}>
                {UserList.savings_bank_name}
              </MenuItem>
              {BankData && BankData.length > 0 ? (
                BankData.map((bank) => (
                  <MenuItem value={bank.Bankname && bank.Bankname.toUpperCase()} key={bank.Bankname}>
                    {bank.Bankname && bank.Bankname.toUpperCase()}
                  </MenuItem>
                ))
              ) : (
                <MenuItem disabled>Loading...</MenuItem> // Disable the loading MenuItem
              )}
            </Select>
          </FormControl>
        </Grid>
        <Grid item xl={3} lg={6} md={6} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Saving Bank IFCS Code"
              name="savings_account_ifsc_code"
              variant="standard"
              inputProps={{
                readOnly: BankAccVerified
              }}
              onChange={(e) => {
                const selectedBank = BankData.find((bank) => bank.Bankname.toUpperCase() === props.postData.savings_bank_name);
                const firstFour = selectedBank ? selectedBank.first_four_ifsc : ''; // Get first four letters

                // Remove non-alphanumeric characters (allows only letters and numbers)
                const sanitizedValue = e.target.value.replace(/[^a-zA-Z0-9]/g, '');

                const remaining = sanitizedValue.slice(firstFour.length); // Allow editing after first four letters

                props.handlePostChange({
                  target: { name: 'savings_account_ifsc_code', value: firstFour + remaining }
                });
              }}
              // onChange={(e) => {
              //   const selectedBank = BankData.find(bank => bank.Bankname.toUpperCase() === props.postData.savings_bank_name);
              //   const firstFour = selectedBank ? selectedBank.first_four_ifsc : ''; // Get the first four letters from selected bank
              //   const remaining = e.target.value.slice(firstFour.length); // Allow editing after first four letters

              //   props.handlePostChange({
              //     target: { name: 'savings_account_ifsc_code', value: firstFour + remaining }
              //   });
              // }}
              value={props.postData.savings_account_ifsc_code ?? UserList.savings_account_ifsc_code ?? ''}
            />
          </FormControl>
        </Grid>
        <Grid item xl={4} lg={6} md={6} sm={6} xs={12} fullwidth>
          <FormControl variant="standard" fullWidth>
            <InputLabel htmlFor="outlined-adornment-lname-register">Bank Account Number</InputLabel>
            <Input
              label="Bank Account Number"
              name="savings_account_number"
              onInput={handleInput}
              onChange={(e) => props.handlePostChange(e)}
              value={props.postData.savings_account_number ?? UserList.savings_account_number ?? ''}
              inputProps={{
                readOnly: BankAccVerified
              }}
              endAdornment={
                !props.postData.savings_bank_name || !props.postData.savings_account_number ? null : (
                  <Button
                    size="small"
                    // sx={{ ml: 2, height: '56px' }}
                    color={BankAccVerified ? 'success' : 'secondary'}
                    onClick={() => {
                      if (!BankAccVerified)
                        handleBankNoVerify(
                          props.postData.savings_account_ifsc_code,
                          props.postData.savings_account_number || UserList.savings_account_number,
                          UserList.aadhaar_name
                        );
                    }}
                  >
                    {BankAccVerified ? 'Verified' : 'Verify'}
                  </Button>
                )
              }
            />
          </FormControl>
        </Grid>

        <Grid item xl={4.5} lg={6} md={6} sm={6} xs={12} fullwidth>
          <FormControl fullWidth>
            <TextField
              label="Saving Holder Name"
              inputProps={{
                readOnly: BankAccVerified
              }}
              variant="standard"
              name="savings_account_holder_name"
              onChange={(e) => props.handlePostChange(e)}
              value={
                props.postData.savings_account_holder_name ??
                UserList.savings_account_holder_name ??
                NameBank ??
                sessionStorage.getItem('od_account_name') ??
                ''
              }
            />
          </FormControl>
        </Grid>
      </Grid>
      <Grid container mt={2} display={'flex'} justifyContent={'center'}>
        <Button
          color="secondary"
          variant="outlined"
          onClick={props.handleBank}
          sx={{
            mr: 2,
            width: '25%',
            borderColor: '#688B2A',
            color: '#688B2A',
            borderRadius: '6px',
            '&:hover': {
              borderColor: '#688B2A'
            }
          }}
        >
          back
        </Button>
        <Button
          color="secondary"
          variant="contained"
          sx={{
            width: '25%',
            backgroundColor: '#688B2A',
            color: '#FFFFFF',
            borderRadius: '6px',
            '&:hover': {
              backgroundColor: '#688B2A'
            }
          }}
          onClick={handleNext}
        >
          update
        </Button>
      </Grid>
    </>
  );
};

export default BankDetails;
